// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimatedNumber_container__YEk4l","countNumber":"AnimatedNumber_countNumber__Zvafz"};